import { apiBinaryRequest, apiRequest } from './apiClient';

const buildQueryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }
    query.set(key, String(value));
  });
  return query.toString();
};

export const fetchFilteredTimeEvents = async (caseId, options = {}) => {
  const query = buildQueryString({
    requestId: options.requestId || '',
    page: Number.isInteger(options.page) ? options.page : 1,
    pageSize: Number.isInteger(options.pageSize) ? options.pageSize : 15,
    filter: options.filter || '',
    showHidden: options.showHidden ? 'true' : 'false',
    visibilityFilter: options.visibilityFilter || '',
    sortBy: options.sortBy || 'date',
    sortOrder: options.sortOrder || 'desc',
    tagVariable: options.tagVariable || '',
    markAsRead: options.markAsRead === false ? 'false' : 'true',
  });

  return apiRequest(`/api/v1/projects/${encodeURIComponent(caseId)}/timeevents${query ? `?${query}` : ''}`, {
    signal: options.signal,
  });
};

export const fetchCalendarData = async (caseId, options = {}) => {
  const query = buildQueryString({
    maxEventsPerDay: Number.isInteger(options.maxEventsPerDay) ? options.maxEventsPerDay : 20,
    year: Number.isInteger(options.year) ? options.year : '',
    month: Number.isInteger(options.month) ? options.month : '',
  });

  return apiRequest(`/api/v1/projects/${encodeURIComponent(caseId)}/calendar${query ? `?${query}` : ''}`, {
    signal: options.signal,
  });
};

export const fetchTimeeventCount = async (caseId) => {
  return apiRequest(`/api/v1/projects/${encodeURIComponent(caseId)}/timeevents/count`);
};

export const fetchTimeeventThumbnail = async (eventId) => {
  const response = await apiBinaryRequest(`/api/v1/timeevents/${encodeURIComponent(eventId)}/thumbnail`);
  return response.blob();
};

export const fetchTimeeventById = async (eventId) => {
  const payload = await apiRequest(`/api/v1/timeevents/${encodeURIComponent(eventId)}`);
  return payload.data ?? payload;
};

export const fetchTagProof = async (tagId, options = {}) => {
  const query = buildQueryString({
    pagination_mode: options.paginationMode || 'offset',
    cursor: options.cursor ?? '',
    limit: Number.isInteger(options.limit) ? options.limit : '',
    offset: Number.isInteger(options.offset) ? options.offset : '',
    search: options.search || '',
    requestId: options.requestId || '',
  });

  const payload = await apiRequest(`/api/v1/tags/${encodeURIComponent(tagId)}/proofs${query ? `?${query}` : ''}`);
  return payload.data ?? payload;
};

export const fetchWidgetEvidence = async (widgetId, kind, options = {}) => {
  const normalizedKind = kind === 'failures' ? 'failures' : 'misses';
  const query = buildQueryString({
    caseid: options.caseId ?? '',
    requestId: options.requestId || '',
    pagination_mode: options.paginationMode || 'cursor',
    cursor: options.cursor ?? '',
    limit: Number.isInteger(options.limit) ? options.limit : '',
    offset: Number.isInteger(options.offset) ? options.offset : '',
    search: options.search || '',
  });

  const payload = await apiRequest(`/api/v1/widgets/${encodeURIComponent(widgetId)}/evidence/${normalizedKind}${query ? `?${query}` : ''}`);
  return payload.data ?? payload;
};

export const fetchWidgetEvidenceMisses = async (widgetId, options = {}) => {
  return fetchWidgetEvidence(widgetId, 'misses', options);
};

export const fetchWidgetEvidenceFailures = async (widgetId, options = {}) => {
  return fetchWidgetEvidence(widgetId, 'failures', options);
};
